<template>
  <span
    class="
      tw-rounded-full
      tw-text-xs
      tw-leading-3
      tw-min-w-4
      tw-h-4
      tw-px-1
      tw-text-sf-snow-lighter
      tw-inline-flex
      tw-justify-center
      tw-items-center
    "
    :class="backgroundClass"
  >
    <slot />
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue'

interface Props {
  ai?: boolean
}
const props = defineProps<Props>()

const backgroundClass = computed(() =>
  props.ai ? 'tw-bg-sf-ai' : 'tw-bg-sf-primary'
)
</script>
